export default __webpack_public_path__ + "static/media/news-icon.ec8fe54f.svg";